import { sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';

export default function trackSEOCopyLinkClick(event: React.MouseEvent<HTMLAnchorElement>) {
  sendGALinkClickEvent(event, {
    event: 'custom_event',
    event_category: 'Category page',
    event_action: 'SEO copy - link click',
    event_label: event.currentTarget.innerText,
    destination_URL: event.currentTarget.href,
  });
}
